export default {
  name: 'Become',
  logo: 'login/become/logo-primary.svg',
  logoMobile: 'login/become/logo-primary-mobile.svg',
  loginImage: 'login/sword/login-image.png',

  // translations keys
  t: {
    // Summary
    onboarding2_download_the_app: 'onboarding2_download_the_app_become',
    eco_download_app_subtitle: 'eco_download_app_subtitle_become',
    // Delete Account
    'account.delete_account_descrtiption': 'account.delete_account_descrtiption_become',
    // Exclusion page
    onboarding2_title_message_thanks_mind: 'onboarding2_title_message_thanks_become',
    onboarding2_mind_excluded: 'onboarding2_become_excluded',
    // Suicide exclusion page
    onboarding2_subtitle_message_mind_suicide: 'onboarding2_subtitle_message_become_suicide',
    // Registration
    onboarding2_account_password_tip: 'onboarding2_account_password_tip_become',
  },
};
